"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBeginTranscriptUploadBody = void 0;
const validation_1 = require("@fmtk/validation");
const UpdateTranscriptBody_1 = require("./UpdateTranscriptBody");
const integerRange_1 = require("../validation/integerRange");
exports.validateBeginTranscriptUploadBody = (0, validation_1.properties)({
    fileName: (0, validation_1.text)(),
    size: (0, integerRange_1.integerRange)(UpdateTranscriptBody_1.MinAudioSize, UpdateTranscriptBody_1.MaxAudioSize),
    type: (0, validation_1.is)(...UpdateTranscriptBody_1.AllowedAudioExtensions),
});
//# sourceMappingURL=BeginTranscriptUploadBody.js.map